module.exports = "<div class=\"general\">\n</div>"